module.exports = __webpack_public_path__ + "img/kx5600-char-3.bb8b939e.png";